import { helper } from '@ember/component/helper';

export function ukCombinedCssClass([value]) {
  switch (value) {
    case 1:
      return '--1';
    case 2:
      return '--2 interim';
    case 3:
      return '--2';
    case 4:
      return '--3';
    case 5:
      return '--3';
    case 6:
      return '--4';
    case 7:
      return '--5';
    default:
      return '--unknown';
  }
}

export default helper(ukCombinedCssClass);
